module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture25-94bde4df57f1a6d21f583768ddb00acd.jpg";